
import { mapActions, mapGetters } from 'vuex'
export default {
  props: {
    value: {
      type: Object,
      default() {
        return {}
      },
    },
  },
  data() {
    return {
      rules: [(v) => !!v || 'Campo obrigatório'],
      loading: false,
      items: [
        'AC',
        'AL',
        'AP',
        'AM',
        'BA',
        'CE',
        'DF',
        'ES',
        'GO',
        'MA',
        'MT',
        'MS',
        'MG',
        'PA',
        'PB',
        'PR',
        'PE',
        'PI',
        'RJ',
        'RN',
        'RS',
        'RO',
        'RR',
        'SC',
        'SP',
        'SE',
        'TO',
      ],
    }
  },
  computed: {
    ...mapGetters('sdagenda', ['sdagenda']),
  },
  methods: {
    ...mapActions('actions-site', ['fetchCep']),
    async searchCep() {
      this.loading = true
      try {
        const data = await this.fetchCep(this.value.cep)
        this.value.bairro = data.bairro
        this.value.cidade = data.localidade
        this.value.logradouro = data.logradouro
        this.value.complemento = data.complemento
        this.value.estado = data.uf
      } catch (error) {
        this.$toast.error('error:' + error)
        console.error(error)
      } finally {
        this.loading = false
      }
    },
  },
}
